<template>
  <v-container style="height: 400px;">
    <v-row
      class="fill-height"
      align-content="center"
      justify="center"
    >
      <v-col
        class="text-subtitle-1 text-center"
        cols="12"
      >
        <slot>Cargando</slot>
      </v-col>
      <v-col cols="6">
        <v-progress-linear
          color="blue"
          indeterminate
          rounded
          height="6"
        ></v-progress-linear>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'custom-progress'
}
</script>

<style scoped>

</style>
